import http from '../httpService';

const AssociationCommunityService = {
  getAssociationCommunity: params => http.get('association-community', { params }),
};

export default AssociationCommunityService;
